import { DEFAULT_STATE } from '../constants'

export const initialFileTypesState = {
  fileTypes: DEFAULT_STATE.fileTypes,
  nativeOnly: DEFAULT_STATE.nativeOnly,
}
